import { RouteObject } from 'react-router-dom';
import { PUB_REPORTS_ROUTE, PUB_REPORTS_ROUTES } from 'router/routes';
import ColumnReports from 'routes/reports/ColumnReports';
import {
  AccountingTab,
  CustomersTab,
  PaginationTab,
  ProductsTab,
  PublicNoticesTab
} from 'routes/reports/ColumnReports/tabs';

export const reportsPublisherRoutes: RouteObject = {
  element: <ColumnReports />,
  children: [
    {
      path: PUB_REPORTS_ROUTE
    },
    {
      path: PUB_REPORTS_ROUTES.PUBLIC_NOTICES,
      element: <PublicNoticesTab />
    },

    {
      path: PUB_REPORTS_ROUTES.PRODUCTS,
      element: <ProductsTab />
    },
    { path: PUB_REPORTS_ROUTES.ACCOUNTING, element: <AccountingTab /> },
    {
      path: PUB_REPORTS_ROUTES.CUSTOMERS,
      element: <CustomersTab />
    },
    {
      path: PUB_REPORTS_ROUTES.PAGINATION,
      element: <PaginationTab />
    }
  ]
};
